import { Link, Typography } from '@mui/material';

const HREF_TYPE = {
	mail: 'mailto:',
	tel: 'tel:',
};

//Note: underline on hover styled like ILIAS link hover effect

const ContactInfoLink = ({ color, info, type, gridArea }) => {
	if (!info || info.length === 0) {
		return null;
	}
	return (
		<Typography sx={{ fontSize: '.75rem', mr: '1rem', gridArea: gridArea, alignSelf: 'center', justifySelf: 'start' }}>
			<Link
				sx={{
					color: color,
					textDecoration: 'none',
					'&:hover': {
						color: `darken(${color}, 10%)`,
						textDecoration: `underline darken(${color}, 10%)`
					}
				}}
				href={`${HREF_TYPE[type]}${info.replace(/ /g, '')}`}>
				{info}
			</Link>
		</Typography>
	);
};

export { ContactInfoLink };